import panchokRequest from '@/utils/requestPanchok';

export const panchokUserLogout = () =>
	panchokRequest({
		url: '/remove-refresh-token',
		method: 'post',
	});

export const checkTokenValidation = data =>
	panchokRequest({
		url: '/giftishow-token/validation',
		method: 'post',
		data,
	});
